import { Component, Inject } from "@angular/core";
import { ActionButton } from "@bitwarden/web-vault/app/components/buttons/gloss-button/actionButton";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CatNotifyButton } from "@bitwarden/web-vault/app/models/types/button.types";
import { isAllLowerCase, isCamelCase } from "@bitwarden/web-vault/app/shared/utils/helper-string";

@Component({
  selector: "app-cta-notification",
  templateUrl: "./cta-notification.component.html",
})
export class CtaNotificationComponent {
  isMessageKey = false;
  closeBtnOptions: ActionButton;
  confirmBtnOptions: ActionButton;
  constructor(
    public dialogRef: MatDialogRef<CtaNotificationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      cancel: CatNotifyButton;
      confirm: CatNotifyButton;
      reminder?: string;
    },
  ) {
    this.closeBtnOptions = new ActionButton({
      text: this.data.cancel.title,
      class: "neutral",
      onClick: () => {
        this.dialogRef.close({ result: "cancel" });
        this.data.cancel.method();
      },
    });

    this.confirmBtnOptions = new ActionButton({
      text: this.data.confirm.title,
      class: "primary",
      onClick: () => {
        this.dialogRef.close(true);
        this.data.confirm.method();
      },
    });

    if (data.message) {
      this.isMessageKey = isAllLowerCase(data.message) || isCamelCase(data.message);
    }
  }

  protected closeDialog() {
    this.dialogRef.close({ result: "cancel" });
  }
}
